goog.provide("shadow.js.shim.module$src$svg$wpp$content$fluid_workflow_svg$default");
shadow.js.shim.module$src$svg$wpp$content$fluid_workflow_svg$default = shadow.js.shim.module$src$svg$wpp$content$fluid_workflow_svg.default;
